var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLonghorizontal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.25 5L5.25 0L10.25 5H0.25Z",
    fill: "#16478E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.25 5L19.25 0L24.25 5H14.25Z",
    fill: "#16478E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_292_3685",
    maskUnits: "userSpaceOnUse",
    x: 0.25,
    y: 7,
    width: 24,
    height: 14,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.25,
    y: 7,
    width: 24,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.25 8H24.25V20H0.25V8Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.25 8H24.25V20H0.25V8Z",
    fill: "#E3EFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.25 9H24.25V7H0.25V9ZM24.25 19H0.25V21H24.25V19Z",
    fill: "#16478E",
    mask: "url(#path-3-outside-1_292_3685)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLonghorizontal);
export default __webpack_public_path__ + "static/media/longhorizontal.cb2b517808b5c3ad5e42e11d5874a7b4.svg";
export { ForwardRef as ReactComponent };